module.exports = __webpack_public_path__ + "static/img/Download.2cee66c5.svg";